export default __webpack_public_path__ + "static/media/inactiveslider.315fd2ef.svg";